<template>
	<page-with-aside :hasFooter="true" >
	
		<template #navheader>
            <site-header></site-header>
        </template>
        
		<template #content>
		<section class="content-header">
				<h1>Open to Options<sup>&trade;</sup></h1>
				<h2>Clarifying your cancer questions</h2>
				<!-- <router-link to="/profile">profile</router-link>
				<router-link to="/accountsetup">accountsetup</router-link>
				<router-link to="/about">about</router-link> --> 
			</section>
		<div class="grid-section">
			<section class="content">
				<p>When you get a cancer diagnosis, everything can become a blur.</p>
				<p>It's common to feel <strong>overwhelmed</strong> with medical terms and <strong>hurried</strong> through doctor’s appointments. With so much going on, it’s <strong>easy to forget</strong> all the important questions you had.</p>
				<p>Open to Options can help.</p>
				<h3>Our chatbot will help you organize your thoughts and questions so you can make the most of your time with the doctor.</h3>
			</section>
		
			<section class="chat-peek">
				<div class="message slide-in-left one">We’ll help you consider:</div>
				<div class="message slide-in-left two">what you know&hellip;</div>
				<div class="message slide-in-left three">what you need to know&hellip;</div>
				<div class="message slide-in-left four">and what your doctor needs to know.</div>
				<div class="message-response slide-in-right">
				<span><button><router-link to="/intro">Tell me more</router-link></button></span>
				</div>
			</section>
		</div>
		
		</template>
	</page-with-aside>
</template>

<style scoped lang="scss">
.grid-section {
	overflow-x:hidden;
}
.slide-in-left {
	transform: translateX(-1000px);
	-webkit-animation: slide-in-left 1.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;
	animation: slide-in-left 1.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) forwards;
	opacity:0;
	//max-width: 100%;
	//overflow: hidden;
	
	&.one {
	animation-delay: 2s;
	}
	&.two {
	animation-delay: 4s;
	}
	&.three {
	animation-delay: 6s;
	}
	&.four {
	animation-delay: 8s;
	}
}
/* ----------------------------------------------
 * Generated by Animista on 2019-11-25 12:44:5
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */
@-webkit-keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
            transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-in-left {
  0% {
    -webkit-transform: translateX(-1000px);
     transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-right {
	//max-width:100%;
	//overflow:hidden;
	-webkit-animation: slide-in-right 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	animation: slide-in-right 1s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	animation-delay: 11s;
	opacity:0;
}
@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(100px);
			transform: translateX(100px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
    opacity: 1;
  }
}
@media(min-width:1000px) {
	@keyframes slide-in-right {
 	 0% {
   		 -webkit-transform: translateX(1000px);
			transform: translateX(1000px);
    	opacity: 0;
  	}
  	100% {
   		 -webkit-transform: translateX(0);
            transform: translateX(0);
   		 opacity: 1;
  		}
	}
}

sup {font-size:50%;}
</style>

 <script>
  import PageWithAside from '@/components/PageWithAside.vue';
  import SiteHeader from '@/components/siteHeader.vue';

   export default {
     name: "Landing",
     components: {
     	"site-header": SiteHeader,
		PageWithAside

 	}
   };
</script>
